import { useState } from "react";

import { Form, Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { openSnackbar } from "Redux/Actions/snackbarActions";
import Loading from "../../MUI_components/loading";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import { Button, CircularProgress } from "@mui/material";
import { REACT_QUERY_KEYS } from "Components/Constants/ReactQueryKeys";
import { useQuery } from "react-query";
import ErrorMessage from "Components/MUI_components/ErrorMessage";
import LedgerTypesService from "Service/Accounts/LedgerTypes.service";
import JournalTypesService from "Service/Accounts/JournalTypes.service";



const SingleEntry = ({ setOpen, code, setSubmitted }) => {
  const dispatch = useDispatch();
  const Validation = yup.object({
    // transactionType: yup.string().required("Transaction type is required"),
    amount: yup.string().required("Amount type is required"),
    // type: yup.string().required("Please get any one"),
  });

  const [initValue, setInitValue] = useState({
    name:"",
    type:null,
  

  });

  const LedgerType = [
    { name: 'CASH BOOK', code: 0 },
    { name: 'BANK', code: 1 },
    { name: 'CREDIT CARD', code: 2 },
    {name:'BOSE' , code:3}
  ]
  
  const EntityType = [
    { name: 'DEBIT', code: 0 },
    { name: 'CREDIT', code: 1 },
  ]

  const TransactionMode = [
    { name: 'CASH', code: 0 },
    { name: 'CHEQUE', code: 1 },
  ]

  const { isError, isLoading, data } = useQuery(
    [REACT_QUERY_KEYS.SINGLE_ENTRY, code],
    () => JournalTypesService.get(code),
    {
      enabled: !!code,
      initialData: initValue
    }
  )

  if (isLoading) {
    return <Loading/>
  }
  if (isError) {
    return <ErrorMessage />
  }


  const handleSubmit = async (values) => {
    console.log(values);
    try {
      if (code)
        await JournalTypesService.edit(values, code);
      else
        await JournalTypesService.create(values);
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `Enrty Type Accounts ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  return (
    <>

      <Formik
        initialValues={data}
        //validationSchema={Validation}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form autoComplete="off">
            <div className="row mt">

            <div className="col-12">
                <FormControl
                  control="input"
                  name="name"
                  label="Transection"
                />

              </div>

             </div>
             <div className="row mt">
              <div className="col-4">
               
              <FormControl
                  control="asynchronousAutoComplete"
                  name="ledgerType"
                  label="Ledger Type"
                  Service={LedgerTypesService}
                  getOptionLabel={(option) =>
                    option.name + "-" + option.code 
                   
                  }
                />
              </div>
              <div className="col-4">
                <FormControl
                  control="autoComplete"
                  name="entryType"
                  label="Entry Type"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={EntityType}
                />
              </div>
              <div className="col-4">
                <FormControl
                  control="autoComplete"
                  name="transactionMode"
                  label="Transection Mode"
                  getOptionLabel={(option) =>
                    option.name
                  }
                  options={TransactionMode}
                />
              </div>
            </div>
            <div className="row flex-end mb">
              <Button

                type="submit"
                style={{ marginRight: 5 }}
                variant="contained"
                color="primary"
                //disabled={isSubmitting}
                startIcon={
                  isSubmitting && (
                    <CircularProgress color="inherit" size={20} />
                  )
                }

              >
                {code ? "Update" : "Save"}
              </Button>
              <Button
                onClick={() => setOpen(false)}
                variant="contained"
                color="secondary"
              >
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SingleEntry;
